export default __webpack_public_path__ + "static/launch_video_poster-25055dc8d50c587dca1af58d3e0b002c.jpg";